import {
    _showClearIcon,
    _dropSingleCommonHtml,
    _dropCommonHtml
} from "./Common_Fun";

import {
    AssertUtils,
    QueryCommand,
    TreeUtils,
    GoingUtils
} from "goingutils";


import dhtmlXTreeView from '../../../dx/dxSource/components/dhtmlXTreeView';
import EditorTypeUtils from "../../../common/editorTypeUtils";



let _initTreeObjAndLoadData = function (
    _inputId,
    targetObj,
    vueObj
) {
    let nodeText = $(`#${_inputId}`).val();
    let nodeId = $(`#` + _inputId.split("_")[0] + "_" + $(`#${_inputId}`).attr("treeRelId")).val();

    let {
        x,
        y
    } = GoingUtils.getElementPosition($(`#${_inputId}`).get(0));
    //设置显示的下拉位置
    $(`#${_inputId}_tree_drop`)
        .show()
        .css("left", x)
        .css("top", y + 2 + parseFloat($(`#${_inputId}`).closest(".input-group").css("height")));

    let initFlag = $(`#${_inputId}_tree_drop`).attr("initFlag");
    //第一次点击初始化数据 第一次以后只是显示即可
    if (initFlag !== "true") {
        targetObj[_inputId] = TreeDrop.initTreeObject(
            _inputId,
            vueObj,
            nodeText,
            nodeId
        );
    }
};

//如果textVal为空 而nodeId又不为空 则需要根据id获取到相应的text内容
let _initInputDefVal = function (inputId, targetObj, vueObj) {
    let textVal = $(`#${inputId}`).val();

    $(`#${inputId}_tree_drop`)
        .show()
        .css("visibility", "hidden");
    let nodeId = $(
        `#` + inputId.split("_")[0] + "_" + $(`#${inputId}`).attr("treeRelId")
    ).val();
    //如果textVal为空 而nodeId又不为空 则需要根据id获取到相应的text内容
    if (!AssertUtils.isNotEmpty(textVal) && AssertUtils.isNotEmpty(nodeId)) {
        _initTreeObjAndLoadData(inputId, targetObj, vueObj);
    }
};
let TreeDrop = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return _dropSingleCommonHtml(
            item,
            targetObj,
            "go-ctl-tree",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(
            item,
            targetObj,
            "go-ctl-tree",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    getRealValue(value) {
        return value || " ";
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            backJson[item["id"]] = $("#" + inputElId).val();
        }

        if (AssertUtils.isNotNull(item["treeRelId"])) {
            //设置关联字段的id
            let treeRelId = `${targetObj.prefixCls}_${item["treeRelId"]}`;
            if (AssertUtils.isNotEmpty($("#" + treeRelId).val())) {
                backJson[item["treeRelId"]] = $("#" + treeRelId).val();
            }
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果编数据下拉
        backJson[item["id"]] = $("#" + inputElId).val();
        //如果树存在关联字段
        if (AssertUtils.isNotNull(item["treeRelId"])) {
            backJson[item["treeRelId"]] = $(
                `#${targetObj.prefixCls}_${item["treeRelId"]}`
            ).val();
        }
    },
    getSearchBox(inputId) {
        return `<div class="clearfix">
                <div  class="search-div pull-left" style="width:calc(100% - 75px)">
                    <div  class="input-icon account-sel-div"><input AUTOCOMPLETE="off" type="text" placeholder="输入查询值" class="form-control"
                    style="border: 0;mrgin-right:5px;">
                    <div  class="search-btn"><i id="${inputId}_search"  class="ivu-icon ivu-icon-ios-search-outline" style="font-size: 18px;"></i></div></div>
               </div><div id="${inputId}_search_btn" style="position: relative;top:3px" class="btn-item btnItem  pull-left"><div class="goBtn primary btn-circle "><!----> <div class="btnLabel">选择</div></div></div></div>`;
    },
    getDropContainerHtml(inputId, inputWidth = 250, inputHeight = 300) {
        if (inputWidth < 250) {
            inputWidth = 250;
        }
        let _inputHeight = inputHeight + "px";
        let zIndex = GoingUtils.getCurMaxZIndex();
        let html = `<div  id="${inputId}_tree_drop"  class="go-common-drop go-tree-ctl" style="position:absolute;zIndex:${zIndex};max-height: 320px; overflow: auto; width: ${inputWidth +"px"};">
                                    ${TreeDrop.getSearchBox(inputId)}
                                    <div id="${inputId}_tree" style="width: 100%;height: ${_inputHeight};"></div>
                                </div>`;
        return html;
    },
    _loadData(inputId, myTreeView, successFun) {
        //获取当前定义的字段属性
        let itemObj = (EditorTypeUtils.itemTemp)[inputId];
        //如果查询url不为空 才需要执行
        if (AssertUtils.isNotEmpty(itemObj["treeUrl"])) {
            //加载数据
            let queryCommand = new QueryCommand({
                url: itemObj["treeUrl"]
            });
            //设置loading显示位置
            queryCommand.$toolTipParent = $(`#${inputId}_tree_drop`);
            //设置是否显示loading
            itemObj["showTip"] == false ? queryCommand.showTip = false : queryCommand.showTip = true;
            //查询数据 如果定义了数据转换函数 则通过转换函数来转换数据
            queryCommand.executeQuery({
                successFun: (backData) => {
                    if(backData==null){
                        return void(0);
                    }
                    if(!AssertUtils.isArray(backData)){
                        if(backData!=null&&backData.data!=null){
                            backData=backData.data;
                        }
                    }
                    let returnData=[];
                    //对数据进行转换
                    if (AssertUtils.isFunction(itemObj.beforeLoadData)) {
                        returnData = itemObj.beforeLoadData(backData);
                    } else {
                        returnData = TreeUtils.getTreeDataJson(backData);
                    }
                    //加载所有数据后 展开所有节点
                    myTreeView.loadStruct(returnData, function () {
                        myTreeView.openAllNode(returnData);
                    });
                    //如果存在回调函数 才需要执行
                    if (AssertUtils.isNotNull(successFun) && AssertUtils.isFunction(successFun)) {
                        successFun();
                    }
                }
            });
        }
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    initTreeObject(inputId) {
        let myTreeView = new dhtmlXTreeView(inputId + "_tree");
        myTreeView.containerId = inputId + "_tree";
        //加载相应数据
        TreeDrop._loadData(inputId, myTreeView);
        //添加初始化标志
        $(`#${inputId}_tree_drop`).attr("initFlag", "true");
        //如果点击的不是控件本身 则隐藏
        $(document).click(function (e) {
            let target = $(e.target);
            if (
                !target.is("#" + inputId + "_container  *") &&
                !target.is("#" + inputId + "_inputDiv .go-content *") &&
                !target.is("#" + inputId + "_inputDiv .go-content") &&
                !target.is("#" + inputId + "_down *") &&
                !target.is("#" + inputId + "_down") &&
                !target.is(`#${inputId}_tree_drop *`) &&
                !target.is(`.dhxtreeview_icon`)
            ) {
                $(`#${inputId}_tree_drop`).hide();
            }
            //如果是点击选中的记录 关闭下拉
            if (target.is(".dhxtreeview_item_text_selected")) {
                $(target)
                    .closest(".go-common-drop")
                    .hide();
            }
        });
        return myTreeView;
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        function _initCtlDefEvent(inputId) {
            //点击输入框 弹出下拉选择数据
            $(`#${inputId}`).click(function () {
                //显示下拉树并加载数据
                let _inputId = $(this).attr("id");
                $(`#${inputId}_tree_drop`)
                    .show().css("zIndex", GoingUtils.getCurMaxZIndex())
                    .css("visibility", "visible");
                _initTreeObjAndLoadData(_inputId, targetObj, vueObj);
            });

            //点击下拉图标 弹出下拉选择
            $(`#${inputId}_down`).click(function () {

                let _inputId = $(this)
                    .attr("id")
                    .split("_down")[0];
                $(`#${inputId}_tree_drop`)
                    .show()
                    .css("visibility", "visible");
                _initTreeObjAndLoadData(_inputId, targetObj, vueObj);
            });

            //点击查询输入框
            $(`#${inputId}_search`).click(function () {
                let val = $(this)
                    .next()
                    .val();
                targetObj[inputId].findItem(val, null, 1);
            });
        }

        //初始化树控件
        $(parentObj)
            .find(".go-ctl-tree")
            .each(function () {
                //如果声明了
                let ctl = $(this).attr("ctl");
                if (ctl === "auto") {
                    let inputId = $(this).attr("id");
                    //获取下拉的容器html代码
                    let html = TreeDrop.getDropContainerHtml(inputId, inputWidth);
                    $(html).appendTo($("#main_router_view"));
                    _initCtlDefEvent(inputId);
                    //设置控件的初始化值
                    _initInputDefVal(inputId, targetObj, vueObj);
                }
            });
    }
};
export default TreeDrop;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-tree-drop.js